import { Request } from 'commons/utils/request'
import { ExportCSVButton } from 'ui/temp/ExportCSVButton'

import { useSiteAuditDocumentsReportContext } from '../../context/SiteAuditDocumentsReportContext'

export const Actions = () => {
  const { data, state } = useSiteAuditDocumentsReportContext()

  return <ExportCSVButton reportName={data.title} url={Request.urls.bank.portalReportSiteCSV} parametersForm={state} />
}
